// extracted by mini-css-extract-plugin
export default {"head-1":"HeaderSection_head-1__DAukN","head-2":"HeaderSection_head-2__iIyBJ"};